module.exports = __webpack_public_path__ + "static/media/logo_s120.6f7c21b6.png";